import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type InsertServiceRunMutationVariables = Types.Exact<{
  run: Types.Mobility_Runs_Insert_Input;
}>;


export type InsertServiceRunMutation = { __typename?: 'mutation_root', insert_mobility_runs_one?: { __typename?: 'mobility_runs', id: number, status: string, departure_time?: string | null, driver_id?: number | null, vehicle_id?: number | null, stops: Array<{ __typename?: 'mobility_stops', id: number, stop_order: number, status: string, location_id?: number | null, address?: string | null, address_lat?: number | null, address_lng?: number | null, service_stop_detail: Array<{ __typename?: 'service_stop_details', stop_id: number, customer_name?: string | null, customer_phone?: string | null }>, service_orders: Array<{ __typename?: 'service_orders', id: number, vehicle_vin?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_year?: number | null, vehicle_color?: string | null }> }> } | null };


export const InsertServiceRunDocument = gql`
    mutation insertServiceRun($run: mobility_runs_insert_input!) {
  insert_mobility_runs_one(object: $run) {
    id
    status
    departure_time
    driver_id
    vehicle_id
    stops(order_by: {stop_order: asc}) {
      id
      stop_order
      status
      location_id
      address
      address_lat
      address_lng
      service_stop_detail {
        stop_id
        customer_name
        customer_phone
      }
      service_orders {
        id
        vehicle_vin
        vehicle_make
        vehicle_model
        vehicle_year
        vehicle_color
      }
    }
  }
}
    `;
export type InsertServiceRunMutationFn = Apollo.MutationFunction<InsertServiceRunMutation, InsertServiceRunMutationVariables>;

/**
 * __useInsertServiceRunMutation__
 *
 * To run a mutation, you first call `useInsertServiceRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertServiceRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertServiceRunMutation, { data, loading, error }] = useInsertServiceRunMutation({
 *   variables: {
 *      run: // value for 'run'
 *   },
 * });
 */
export function useInsertServiceRunMutation(baseOptions?: Apollo.MutationHookOptions<InsertServiceRunMutation, InsertServiceRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertServiceRunMutation, InsertServiceRunMutationVariables>(InsertServiceRunDocument, options);
      }
export type InsertServiceRunMutationHookResult = ReturnType<typeof useInsertServiceRunMutation>;
export type InsertServiceRunMutationResult = Apollo.MutationResult<InsertServiceRunMutation>;
export type InsertServiceRunMutationOptions = Apollo.BaseMutationOptions<InsertServiceRunMutation, InsertServiceRunMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/mobileService/queries/insertServiceRun.mutation.gql}
 */
export async function insertServiceRun(
  variables: InsertServiceRunMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertServiceRunMutation['insert_mobility_runs_one']>
export async function insertServiceRun(
  variables: InsertServiceRunMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertServiceRunMutation>
export async function insertServiceRun(
  variables: InsertServiceRunMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertServiceRunMutation['insert_mobility_runs_one'] | InsertServiceRunMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertServiceRunMutation>(
    InsertServiceRunDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_mobility_runs_one
}